export default __webpack_public_path__ + "static/img_interviewee_hjpark@2x-855e33c60c2d6ae733dd62352fd40777.png";